import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { DEFAULT_SETTINGS, COURSES, DEPARTMENTS, STUDENT_LIFE, DEFAULT_GALLERY, DEFAULT_SUBJECTS, DEFAULT_TEAM, DEFAULT_SEMESTERS, DEFAULT_RECORDS, DEFAULT_MARKSHEETS, DEFAULT_SYLLABUS, DEFAULT_PROSPECTUS, DEFAULT_SLIDES } from "../data/site";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [courses, setCourses] = useState(COURSES);
  const [departments, setDepartments] = useState(DEPARTMENTS);
  const [students, setStudents] = useState(STUDENT_LIFE);
  const [gallery, setGallery] = useState(DEFAULT_GALLERY);
  const [subjects, setSubjects] = useState(DEFAULT_SUBJECTS);
  const [team, setTeam] = useState(DEFAULT_TEAM);
  const [semesters, setSemesters] = useState(DEFAULT_SEMESTERS);
  const [records, setRecords] = useState(DEFAULT_RECORDS);
  const [marksheets, setMarksheets] = useState(DEFAULT_MARKSHEETS);
  const [syllabus, setSyllabus] = useState(DEFAULT_SYLLABUS);
  const [prospectus, setProspectus] = useState(DEFAULT_PROSPECTUS);
  const [slides, setSlides] = useState(DEFAULT_SLIDES);

  const reload = useCallback(async () => {
    try {
      const [s, c, d, st, g, sub, tm, sem, rec, ms, syl, pros, sl] = await Promise.all([
        api.getSettings(), api.list("courses"), api.list("departments"), api.list("students"), api.list("gallery"), api.list("subjects"), api.list("team"), api.list("semesters"), api.list("records"), api.list("marksheets"), api.list("syllabus"), api.list("prospectus"), api.list("slides"),
      ]);
      if (s.data) setSettings(s.data);
      if (Array.isArray(c.data)) setCourses(c.data);
      if (Array.isArray(d.data)) setDepartments(d.data);
      if (Array.isArray(st.data)) setStudents(st.data);
      if (Array.isArray(g.data)) setGallery(g.data);
      if (Array.isArray(sub.data)) setSubjects(sub.data);
      if (Array.isArray(tm.data)) setTeam(tm.data);
      if (Array.isArray(sem.data)) setSemesters(sem.data);
      if (Array.isArray(rec.data)) setRecords(rec.data);
      if (Array.isArray(ms.data)) setMarksheets(ms.data);
      if (Array.isArray(syl.data)) setSyllabus(syl.data);
      if (Array.isArray(pros.data)) setProspectus(pros.data);
      if (Array.isArray(sl.data)) setSlides(sl.data);
    } catch (e) {
      /* keep defaults */
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <SiteContext.Provider value={{ settings, courses, departments, students, gallery, subjects, team, semesters, records, marksheets, syllabus, prospectus, slides, reload }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
